export default __webpack_public_path__ + "static/media/DEMO_ICONA.920fc6b5.svg";